import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/helping-loved-one-with-depression")({
  beforeLoad: () => {
    throw redirect({ to: "/helping-someone-with-depression", replace: true });
  },
});
